import { api } from './axios';
import { authService } from './auth';

export interface Pais {
  id: number;
  name: string;
  created_at?: string;
  updated_at?: string;
}

export interface Estado {
  id: number;
  name: string;
  pais_fk: number;
  created_at?: string;
  updated_at?: string;
}

export interface Cidade {
  id: number;
  name: string;
  estado_fk: number;
  created_at?: string;
  updated_at?: string;
}

class PaisService {
  /**
   * Listar todos os países
   */
  async getPaises(): Promise<Pais[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Pais[]>('/paises');
    return response.data;
  }

  /**
   * Listar todos os estados
   */
  async getEstados(): Promise<Estado[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Estado[]>('/estados');
    return response.data;
  }

  /**
   * Listar todas as cidades
   */
  async getCidades(): Promise<Cidade[]> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<Cidade[]>('/cidades');
    return response.data;
  }
}

export const paisService = new PaisService();
